import SubHeadings from "../../components/SubHeadings";
import { Info } from "./AddPayroll";
import { useState } from "react";
import UpdateDetailsPayroll from "../../components/modal/UpdateDetailsPayroll";
import { info } from "../../asset";
import { Staff } from "../../types/staff";
import { formatRoleForDisplay } from "../../util/functions/UniversalFunctions";

export default function BasicDetails({
  onNext,
  data,
}: {
  onNext: () => void;
  data: Staff;
}) {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <div className="bg-white rounded-lg p-6">
      <div className="flex">
        <div className="flex flex-col gap-8 w-full">
          <div className="grid grid-cols-3 gap-8">
            <Info label="Staff Name" value={data?.fullName || "---"} />
            <Info label="Staff ID" value={data?.employeeCode} />
            <Info
              label="Designation"
              value={formatRoleForDisplay(data?.roleName || "---")}
            />
          </div>

          <div className="flex w-full gap-20">
            <Info
              label="Date of Joining"
              value={data?.dateOfJoining || "---"}
            />
            <Info label="Gender" value={data?.gender || "---"} />
            <Info label="Email Address" value={data?.email || "---"} />
            <Info label="Mobile Number" value={data?.mobile || "---"} />
          </div>
        </div>

        <div className="w-full max-w-[150px]">
          {!data?.profile_image_url ? (
            <div className="flex items-center justify-center text-5xl w-24 h-24 rounded-full bg-primary-600 text-white font-semibold">
              {data?.fullName.charAt(0).toUpperCase()}
            </div>
          ) : (
            <img
              src={data?.profile_image_url}
              alt="profile"
              className="w-24 h-24 rounded-full object-cover bg-background-200"
            />
          )}
        </div>
      </div>

      <label className="flex items-center gap-2 text-sm mt-9 text-neutral-500">
        <input type="checkbox" className="w-3 h-3" />
        Allow staffs to download their payslip
      </label>

      <div className="border-t pt-5 flex flex-col gap-6 mt-5">
        <SubHeadings text="Personal Details" />

        <div className="grid grid-cols-4 gap-6">
          <Info label="Aadhar Number" value={data?.aadhaarNumber || "---"} />
          <Info label="PAN Number" value={data?.panNumber || "---"} />
          <Info label="Employee Type" value={data?.employeeType || "---"} />
          <Info label="Birth Date" value={data?.dateOfBirth || "---"} />
        </div>

        <div className="flex gap-24 mt-8">
          <Info label="Father’s Name" value={data?.fatherName || "---"} />
          <Info
            label="Communication Address"
            value={data?.permanentAddress || "---"}
          />
        </div>
      </div>

      <div className="flex justify-end gap-4 pt-4 mt-8">
        <button
          onClick={() => setShowPopup(true)}
          className="px-6 py-2 border border-success-700 text-success-700 rounded-lg text-sm font-medium"
        >
          Update Details
        </button>
        <button
          className="px-6 py-2 bg-success-700 text-white rounded-lg text-sm font-medium"
          onClick={onNext}
        >
          Save and Continue
        </button>
      </div>
      {showPopup && (
        <UpdateDetailsPayroll
          icon={info}
          description="In order to update any Staff related details, please navigate to Staff → Staff Profile → Edit → Submit"
          onClose={() => setShowPopup(false)}
        />
      )}
    </div>
  );
}
